type Props = {
    color?: string;
    width?: number;
    height?: number;
};

export default function IconClose({
    color = 'black',
    width = 22,
    height = 22,
}: Props) {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 22 22"
            fill={color}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M11.0002 12.2833L6.50856 16.775C6.34051 16.943 6.12662 17.0271 5.86689 17.0271C5.60717 17.0271 5.39328 16.943 5.22523 16.775C5.05717 16.6069 4.97314 16.393 4.97314 16.1333C4.97314 15.8736 5.05717 15.6597 5.22523 15.4917L9.7169 11L5.22523 6.50832C5.05717 6.34026 4.97314 6.12637 4.97314 5.86665C4.97314 5.60693 5.05717 5.39304 5.22523 5.22498C5.39328 5.05693 5.60717 4.9729 5.86689 4.9729C6.12662 4.9729 6.34051 5.05693 6.50856 5.22498L11.0002 9.71665L15.4919 5.22498C15.66 5.05693 15.8738 4.9729 16.1336 4.9729C16.3933 4.9729 16.6072 5.05693 16.7752 5.22498C16.9433 5.39304 17.0273 5.60693 17.0273 5.86665C17.0273 6.12637 16.9433 6.34026 16.7752 6.50832L12.2836 11L16.7752 15.4917C16.9433 15.6597 17.0273 15.8736 17.0273 16.1333C17.0273 16.393 16.9433 16.6069 16.7752 16.775C16.6072 16.943 16.3933 17.0271 16.1336 17.0271C15.8738 17.0271 15.66 16.943 15.4919 16.775L11.0002 12.2833Z" />
        </svg>
    );
}
